import * as Common from '@/tenant/common';

export class CommodityJournalReportQuery extends Common.Query {
    constructor(){
        super("CommodityJournalReportQuery", null);
    }
    public templateId:number=0;
    public dateFrom: Date = null;
    public dateTo: Date = null;
    public segment: Common.Segment = null;
    public counterpart: Common.Counterpart = null;
    public warehouse: Common.Counterpart = null;
    public commodity: Common.Commodity = null;
    public commodityCategory: Common.Category = null;
    public onExcelExport:boolean = false;           
}

export class CommodityJournalReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='CommodityJournalReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}